import { Card, Drawer, Form, Input, Menu, MenuProps, Space, Button as AntButton, Spin, Tooltip, Modal } from "antd";
import { useCallback, useMemo, useState } from "react";
import { Button } from "react-bootstrap";
import TextArea from "antd/lib/input/TextArea";
import { RoleService } from "../../../../../../services/config/permission-config/role";
import { CreateNotification } from "../../../../../../components/notifier";
import { useRole } from "../../hooks/use-role";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../../../../AppRoutes";
import { useSearchParams } from "../../../../../../hook/use-search-params";
import { useQueryClient } from "@tanstack/react-query";
import "./TableLeftContent.scss";
import { HiOutlineTrash, HiPencilSquare } from "react-icons/hi2";
import { AlternatePeoplePicker } from "../../../../../../components/select/alternate-people-picker";
import { useConfigEmployee } from "../../hooks/use-config-employee";
import { useUser } from "../../../../../../hook";

type MenuItem = Required<MenuProps>["items"][number];

type MenuItemDataType = {
  label: string;
  description: string;
  key: string;
};

export const TabLeftContent = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const { listRoles, isLoading } = useRole();
  const history = useHistory();
  const {email} = useUser();
  const { searchParams } = useSearchParams();
  const queryClient = useQueryClient();
  const { addEmployee } = useConfigEmployee();
  const [selectedItem, setSelectedItem] = useState(null as any);
  const tabId = searchParams.get("tab");
  const listAdmin = [
    'canbo1@viags.vn',
    'thiennv@viags.vn',
  ]

  const listChatbot = [
    'canbo1@viags.vn',
    'thiennv@viags.vn',
    'hunghuy@viags.vn',
  ]

  const handleEditGroup = useCallback(
    (key: string) => {
      const role = listRoles?.find((e: any) => e.key === key);
      const newRole = {
        roleName: role?.label,
        note: role?.note,
        description: role?.description,
        id: role?.key ? +role.key : -1,
      };
      setSelectedItem(newRole);
      form.resetFields();
      setTimeout(() => setIsModalOpen(true), 0);
    },
    [form, listRoles]
  );

  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: "group"
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    } as MenuItem;
  }

  const onRemove = async (id: string) => {
    try {
      await RoleService.deleteRole(+id);
      CreateNotification({
        title: "Thành công",
        body: "Xoá nhóm thành công",
        icon: "/icons/success.png",
      });
      queryClient.invalidateQueries({ queryKey: ["config-role"] });
      history.push({ pathname: Routes.ConfigProcedure.path, search: `configId=14&tab=${tabId}&menuId=1` });
    } catch (error) {}
  };

  const showDeleteConfirm = (id: string) => {
    Modal.confirm({
      title: "Thông báo",
      content: "Anh/chị vui lòng xác nhận xoá dữ liệu đã chọn!",
      okText: "Xác nhận",
      okType: "danger",
      okButtonProps: { type: "primary" },
      cancelText: "Huỷ",
      onOk() {
        onRemove(id);
      },
    });
  };

  const menu = useMemo(() => {
    const MenuItem = (e: MenuItemDataType, isHidden: boolean, isVisible: boolean) =>
      isLoading ? (
        <Spin tip="Đang tải dữ liệu..."></Spin>
      ) : (
        <Space className="justify-content-between align-items-center" style={{ width: "100%" }}>
          <div className="d-flex flex-column">
            <span>{e.label}</span>
          </div>
          <div className="d-flex" hidden={isHidden}>
            <AntButton
              type="link"
              className="role-hoverable-button"
              style={{ border: 0, padding: "5px" }}
              onClick={() => handleEditGroup(e.key)}
            >
              <Tooltip title="Chỉnh sửa" color="blue">
                <HiPencilSquare size={20} className="cursor-pointer" color="#0ea5e9" />
              </Tooltip>
            </AntButton>
            <AntButton type="link" className="role-hoverable-button" style={{ border: 0, padding: "5px" }}>
              <Tooltip title="Xóa nhóm" color="volcano">
                <HiOutlineTrash
                  size={20}
                  className="cursor-pointer"
                  color="#dc2626"
                  onClick={() => showDeleteConfirm(e.key)}
                />
              </Tooltip>
            </AntButton>
          </div>
        </Space>
      );

    const menuId = searchParams.get("menuId") || listRoles?.at(0)?.key || "54";

    const isVisible = (key: string) => (key === "54" && listAdmin.includes(email?.toLowerCase())) || (key === "60" && listChatbot.includes(email?.toLowerCase()))

    const items: MenuItem[] = listRoles.map((e: MenuItemDataType) => getItem(MenuItem(e, menuId !== e.key, isVisible(e.key)), e.key));

    return (
      <Menu
        selectedKeys={[menuId]}
        theme="light"
        mode="inline"
        items={items}
        style={{ height: "100%", minHeight: "400px" }}
        onSelect={(e) =>
          history.push({ pathname: Routes.ConfigProcedure.path, search: `configId=14&tab=${tabId}&menuId=${e.key}` })
        }
      />
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleEditGroup, history, isLoading, listRoles, searchParams]);

  const handleCloseModal = () => {
    setIsModalOpen(!isModalOpen);
    setSelectedItem(null);
    form.resetFields();
  };

  const crudRole = async (formData: { roleName: string; employee: string[]; note: string }) => {
    const commonFields = {
      roleName: formData.roleName,
      description: formData.note,
      note: formData.note,
    };
    let roleId = selectedItem?.id;
    try {
      if (selectedItem) {
        const updateFields = {
          ...commonFields,
          id: roleId,
        };
        setIsLoadingModal(true);
        const res = await RoleService.updateRole(updateFields);
        if (res.statusCode === 200) {
          setIsLoadingModal(false);
          CreateNotification({
            title: "Thành công",
            body: "Cập nhật thông tin nhóm thành công",
            icon: "/icons/success.png",
          });
        }
        setIsModalOpen(false);
        queryClient.invalidateQueries({ queryKey: ["config-role"] });
      } else {
        const createFields = {
          ...commonFields,
          permissions: [
            {
              permissionId: 5,
              c: false,
              r: false,
              u: false,
              d: false,
            },
          ],
        };
        setIsLoadingModal(true);
        const res = await RoleService.addRole(createFields);
        if (res.statusCode === 200) {
          CreateNotification({
            title: "Thành công",
            body: "Tạo nhóm thành công",
            icon: "/icons/success.png",
          });
          roleId = res.data;
          if (formData.employee) {
            const employees = [...formData.employee];
            await addEmployee(employees, roleId);
            await queryClient.invalidateQueries({ queryKey: ["config-employee"] });
          }
          await queryClient.invalidateQueries({ queryKey: ["config-role"] });
          history.push({ pathname: Routes.ConfigProcedure.path, search: `configId=14&tab=${tabId}&menuId=${roleId}` });
        } else {
          CreateNotification({
            title: "Thông báo",
            body: "Tạo nhóm không thành công!. " + res.message,
            icon: "/icons/warning.png",
          });
        }
        setIsLoadingModal(false);
        setIsModalOpen(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onFormChange = async (e: { roleName: string; employee: string[]; note: string }) => {
    crudRole(e);
  };

  return (
    <div style={{ flex: 1 }}>
      <Button style={{ margin: "10px", marginLeft: 0 }} variant="primary" onClick={handleCloseModal}>
        Thêm mới
      </Button>
      <Card
        title="Nhóm"
        size="default"
        headStyle={{ border: "1px solid rgba(143, 155, 179, 0.3)" }}
        bodyStyle={{ border: "1px solid rgba(143, 155, 179, 0.3)" }}
      >
        {menu}
      </Card>
      <Drawer
        title={selectedItem ? "Chỉnh sửa nhóm quyền" : "Tạo nhóm quyền mới"}
        placement="right"
        size={"large"}
        onClose={handleCloseModal}
        open={isModalOpen}
        destroyOnClose
        footer={
          <Space style={{ float: "right" }}>
            <Button variant="secondary" onClick={handleCloseModal} style={{width: "88px", height: "32px"}}>
              Đóng
            </Button>
            <AntButton type="primary" htmlType="submit" onClick={() => form.submit()}>
              Xác nhận
            </AntButton>
          </Space>
        }
      >
        <Spin spinning={isLoadingModal}>
          <Form
            labelCol={{ span: 4 }}
            form={form}
            layout="horizontal"
            onFinish={onFormChange}
            initialValues={selectedItem}
          >
            <Form.Item label="Tên nhóm" name="roleName">
              <Input />
            </Form.Item>
            <Form.Item label="Thành viên" name="employee" hidden={selectedItem}>
              <AlternatePeoplePicker placeholder="Thêm thành viên" />
            </Form.Item>
            <Form.Item label="Ghi chú" name="note">
              <TextArea rows={4} />
            </Form.Item>
          </Form>
        </Spin>
      </Drawer>
    </div>
  );
};
